<app-navbar (pixelHeightChanged)="setTopMarginForNavbar($event)"></app-navbar>

<div class="container mt-4" [style]="'padding-top: ' + topMargin + 'px;'">
  <wm-contractor-profile
    *ngIf="contractorId"
    [contractorId]="contractorId"
  ></wm-contractor-profile>
</div>
